import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getAccessoryParts } from '../thunks/partsThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearPartsKey } from '../thunkKeys/partsThunksKeys';

const SLICE_NAME = 'accessoryParts';

export const accessoryPartsSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearAccessoryParts(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getAccessoryParts });
        builder.addCase(clearPartsKey, () => commonInitialState);
    },
});

export const { clearAccessoryParts } = accessoryPartsSlice.actions;

export const accessoryParts = accessoryPartsSlice.reducer;
